export const containsInvalidDataSets = (dataSets) => {
    if (dataSets.length === 0) {
        return false;
    }
    const emptySets = dataSets.map((set) => {
        return set.data.length === 0;
    });
    return emptySets.some((e) => e === true);
};
